/** Drag-and-drop data type identifiers. */
export const DND_BLOCK = 'application/x-editor-block';
export const DND_NEW_BLOCK = 'application/x-editor-new-block';
